import React from 'react';

import { useTranslation } from 'react-i18next';

import { useProjectActivityContext } from 'components/contexts/ProjectActivityContext';

export default function ActivityTableHeaders() {
  const { isVersionPdfsEnabled } = useProjectActivityContext();

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <tr className='handshq__tr--grey tw-bg-grey-050'>
      {isVersionPdfsEnabled && (
        <th className='tw-w-[8%] tw-text-center tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
          {i18nTShared('version')}
        </th>
      )}
      <th className='tw-w-[20%] tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
        {i18nTShared('date')}
      </th>
      <th className='tw-w-[62%] tw-pl-12 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
        {i18nTShared('change')}
      </th>
      <th className='tw-w-[15%]' />
    </tr>
  );
}
